import React, { useState } from 'react';

interface Item {
  id: string | number;
  nome: string;
}

interface DualListBoxProps {
  availableItems: Item[];
  selectedItems: Item[];
  onMoveToSelected: (items: Item[]) => void;
  onMoveAllToSelected: () => void;
  onMoveToAvailable: (items: Item[]) => void;
  onMoveAllToAvailable: () => void;
  availableLabel?: string;
  selectedLabel?: string;
}

const DualListBox: React.FC<DualListBoxProps> = ({
  availableItems,
  selectedItems,
  onMoveToSelected,
  onMoveAllToSelected,
  onMoveToAvailable,
  onMoveAllToAvailable,
  availableLabel = 'Disponíveis',
  selectedLabel = 'Selecionados'
}) => {

  const [highlightedAvailable, setHighlightedAvailable] = useState<string[]>([]);
  const [highlightedSelected, setHighlightedSelected] = useState<string[]>([]);

  const moveRight = () => {
    const itemsToMove = availableItems.filter(item => highlightedAvailable.includes(String(item.id)));
    onMoveToSelected(itemsToMove);
    setHighlightedAvailable([]);
  };

  const moveLeft = () => {
    const itemsToMove = selectedItems.filter(item => highlightedSelected.includes(String(item.id)));
    onMoveToAvailable(itemsToMove);
    setHighlightedSelected([]);
  };

  const sortedAvailable = [...availableItems].sort((a, b) => a.nome.localeCompare(b.nome));
  const sortedSelected = [...selectedItems].sort((a, b) => a.nome.localeCompare(b.nome));

  return (
    <div className="row align-items-center">
      <div className="col-md-5">
        <h6>{availableLabel}</h6>
        <select
          multiple
          className="form-control"
          style={{ height: '250px' }}
          value={highlightedAvailable}
          onChange={(e) => setHighlightedAvailable(Array.from(e.target.selectedOptions, option => option.value))}
        >
          {sortedAvailable.map(item => (
            <option key={item.id} value={item.id}>
              {item.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-2 text-center">
        <div className="d-flex flex-column gap-2">
 <button type="button" onClick={moveRight} style={{ margin: '5px' }} disabled={highlightedAvailable.length === 0}>
      &gt;
    </button>
    <button type="button" onClick={onMoveAllToSelected} style={{ margin: '5px' }} disabled={availableItems.length === 0}>
      &gt;&gt;
    </button>
    <button type="button" onClick={moveLeft} style={{ margin: '5px' }} disabled={highlightedSelected.length === 0}>
      &lt;
    </button>
    <button type="button" onClick={onMoveAllToAvailable} style={{ margin: '5px' }} disabled={selectedItems.length === 0}>
      &lt;&lt;
    </button>
        </div>
      </div>

      <div className="col-md-5">
        <h6>{selectedLabel}</h6>
        <select
          multiple
          className="form-control"
          style={{ height: '250px' }}
          value={highlightedSelected}
          onChange={(e) => setHighlightedSelected(Array.from(e.target.selectedOptions, option => option.value))}
        >
          {sortedSelected.map(item => (
            <option key={item.id} value={item.id}>
              {item.nome}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DualListBox;
